import ActiveCellItemStore from '@stores/paginated-table-hierarchy-items/ActiveCellItemStore'
import { action, observable } from 'mobx'

export default class OrderCellActiveCellItemStore extends ActiveCellItemStore {
  @observable sizeIndex = -1

  @action
  setSizeIndex = (index: number) => {
    this.sizeIndex = index
  }
}
